import Analytics from './Analytics';
import BrainbayLogo from './Brainbay';
import Browser from './Browser';
import FundaLogo from './Funda';
import ZapierLogo from './Zapier';
import RealworksLogo from './Realworks';
import Hypotheekbond from './Hypotheekbond';
import ARXGroepLogo from './ARXGroepLogo';
import ARXGroepEmblem from './ARXGroepEmblem';
import Trustoo from './Trustoo';
import TrustooEmblem from './TrustooEmblem';
import Duurzaamheidsprofiel from './Duurzaamheidsprofiel';
import Bndl from './Bndl';

export type LogoType = keyof typeof logos;

export type Props = React.SVGAttributes<SVGElement> & {
  color?: string;
  secondary?: boolean;
  maxWidth?: string;
};

const logos = {
  bndl: Bndl,
  brainbay: BrainbayLogo,
  funda: FundaLogo,
  browser: Browser,
  analytics: Analytics,
  zapier: ZapierLogo,
  realworks: RealworksLogo,
  hypotheekbond: Hypotheekbond,
  arxGroep: ARXGroepLogo,
  arxGroepEmblem: ARXGroepEmblem,
  trustoo: Trustoo,
  trustooEmblem: TrustooEmblem,
  susReport: Duurzaamheidsprofiel,
};

export default logos;
